export default "__VITE_ASSET__qxPvLIfx__"